export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/calendar/Constants.js
// module id = 276
// module chunks = 0